<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.id') }}:</label>
                <div>
                    <el-input v-model="filterData.id" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.orderID') }}:</label>
                <div>
                    <el-input v-model="filterData.order_id" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.user') }}:</label>
                <div>
                    <el-select
                        class="w-100"
                        v-model="filterData.user_id"
                        :filterable="user.filterable"
                        clearable
                        remote
                        :remote-method="remoteSearchUser"
                        :loading="user.loading"
                        :placeholder="$t('filters.ecommerce.invoice.userSearch')">
                        <el-option v-for="(user, userIndex) in user.list" :key="userIndex" :value="user.id" :label="user.full_name + ' (' + user.email +')'"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.status') }}:</label>
                <div>
                    <el-select v-model="filterData.status_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option v-for="(state, stateIndex) in status" :key="stateIndex" :value="stateIndex" :label="$t('pages.ecommerce.invoiceManagement.invoice.status.' + state)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.invoiceType') }}:</label>
                <div>
                    <el-select v-model="filterData.user_invoice_type_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="1" :label="$t('common.individual')"></el-option>
                        <el-option :value="2" :label="$t('common.corporate')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.sendToProvider') }}:</label>
                <div>
                    <el-select v-model="filterData.send_to_provider" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('common.yes')"></el-option>
                        <el-option :value="false" :label="$t('common.no')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.providerLegalizeStatus') }}:</label>
                <div>
                    <el-select v-model="filterData.provider_legalize_status_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option v-for="(legalizeState, legalizeStateIndex) in providerLegalizeStatus" :key="legalizeStateIndex" :value="legalizeStateIndex" :label="$t('pages.ecommerce.invoiceManagement.invoice.providerLegalizeStatus.' + legalizeState)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.hasRuntimeError') }}:</label>
                <div>
                    <el-select v-model="filterData.has_runtime_error" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="true" :label="$t('common.yes')"></el-option>
                        <el-option :value="false" :label="$t('common.no')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="">
                <label class="form-label fw-bold">{{ $t('filters.ecommerce.invoice.paymentMethodApproved') }}:</label>
                <div>
                    <el-radio-group v-model="filterData.payment_method_approved" @change="changedOnlyUserOrder">
                        <el-radio-button :label="true">{{ $t("common.yes") }}</el-radio-button>
                        <el-radio-button :label="false">{{ $t("common.no") }}</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="separator border-gray-200"></div>
        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            filterData: {
                payment_method_approved: true
            },
            user: {
                filterable: true,
                loading: false,
                list: []
            },
            status: ['notPaid', 'paid', 'cancelled'],
            providerLegalizeStatus: ['notStart', 'pending', 'success', 'error']
        }
    },
    methods: {
        onReset() {
            this.filterData = {};
            this.onFilter();
        },
        onFilter() {
            this.$emit('onFilter', this.filterData);
        },
        remoteSearchUser(query) {
            if (query) {
                this.user.loading = true;
                this.axios.get(this.endpoints['user'], {
                    params: {
                        magic: query
                    }
                }).then(response => {
                    let data = response.data.data;
                    this.user.list = data;
                }).finally(() => {
                    this.user.loading = false;
                });
            } else {
                this.user.list = [];
            }
        },
    }
}
</script>

<style>

</style>